(function() {
  'use strict';

  // Check for reduced motion preference
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Entrance animations: trigger when user scrolls into view
  var booksSection = document.querySelector('.featured-books');
  if (!booksSection) return;

  var entranceTriggered = false;

  function checkEntrance() {
    if (entranceTriggered) return;
    var rect = booksSection.getBoundingClientRect();
    var midpoint = rect.top + rect.height * 0.4;
    if (midpoint < window.innerHeight) {
      if (!prefersReduced) {
        booksSection.classList.add('doodles-visible');
      }
      entranceTriggered = true;
    }
  }

  // Lightweight parallax on [data-speed] doodles
  var parallaxEls = document.querySelectorAll('.doodle-parallax');
  var ticking = false;

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      // Check entrance trigger on every frame
      checkEntrance();

      // Parallax
      if (parallaxEls.length && booksSection) {
        var rect = booksSection.getBoundingClientRect();
        var sectionTop = rect.top;
        var windowH = window.innerHeight;

        if (sectionTop < windowH && sectionTop + rect.height > 0) {
          var scrollProgress = (windowH - sectionTop) / (windowH + rect.height);
          parallaxEls.forEach(function (el) {
            var speed = parseFloat(el.dataset.speed) || 0.3;
            var offset = (scrollProgress - 0.5) * 600 * speed;
            el.style.transform = 'translateY(' + offset + 'px)';
          });
        }
      }
      ticking = false;
    });
  });


})();
